import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fca1d2ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "code_login" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("登录")

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { showNotify, showLoadingToast, closeToast } from "vant"
import { getCodeApi, getAccountAPi, getTokenAPi } from "@/api/login"
import commons from "@/utils/commons"
import { removeAll, getToken, setToken, setExpiresIn, setRefreshToken, getRefreshToken } from "@/utils/cookies"

export default /*#__PURE__*/_defineComponent({
  __name: 'codeLogin',
  setup(__props) {

const route = useRoute()
const disableds = ref(false)
const content = ref("获取验证码")
const totalTime = ref(60)
const formData = ref({
  phone: "",
  code: ""
})
onMounted(() => {
  // 缓存openid备用
  if (route.query?.openId) {
    localStorage.setItem("openId", route.query.openId)
  }
})
// 获取验证码
const getCode = async () => {
  if (!formData.value.phone) {
    showNotify({ type: "warning", duration: 500, message: "请输入手机号" })
  } else {
    // 手机号码校验
    let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
    if (!reg.test(formData.value.phone)) {
      showNotify({ type: "warning", duration: 500, message: "请输入正确的手机号格式" })
    } else {
      disableds.value = true
      showLoadingToast({
        message: "验证码发送中..."
      })
      try {
        var formDatas = new FormData()
        formDatas.append("mobilePhone", formData.value.phone)
        getCodeApi(formDatas).then((res: any) => {
          if (res.code == 200) {
            showNotify({ type: "success", message: "验证码已经发送" })
            closeToast()
            // 倒计时
            let clock = setInterval(() => {
              content.value = totalTime.value + "s"
              totalTime.value--
              if (totalTime.value < 0) {
                totalTime.value = 60
                content.value = "重新发送验证码"
                disableds.value = false
                clearInterval(clock)
              }
            }, 1000)
          } else {
            closeToast()
            disableds.value = false
            showNotify({ type: "danger", message: res.message })
          }
        })
      } catch (err: any) {
        disableds.value = false
        console.log(err)
      }
    }
  }
}
const onSubmit = () => {
  var datas = {
    accountType: route.query.account_type,
    code: formData.value.code,
    mobilePhone: formData.value.phone
  }
  showLoadingToast({
    message: "登录中..."
  })
  getAccountAPi(datas).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      getTokens(res.data)
      localStorage.setItem("loginCode", res.data)
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取token
const getTokens = async (datas: any) => {
  showLoadingToast({
    message: "登录中..."
  })
  getTokenAPi(datas, commons.setT026()).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      console.log(res)
      setToken(res.data)
      showNotify({ type: "success", message: "登录成功" })
      // 如果有参数fromResourceId  需要跳转到资源详情页面
      if (route.query.fromResourceId) {
        router.replace({ path: "/resource/detail", query: { id: route.query.fromResourceId } })
      } else {
        router.replace({ path: "/home" })
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      class: "van-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, {
          inset: "",
          class: "input_phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: formData.value.phone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.phone) = $event)),
              left: "",
              clearable: "",
              label: "+86",
              placeholder: "请输入手机号",
              rules: [
            { required: true, message: '请输入手机号' },
            { pattern: /^\d{11}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
          ],
              type: "tel",
              "format-trigger": "onBlur",
              "input-class": "prevent-zoom"
            }, {
              button: _withCtx(() => [
                _createVNode(_component_van_button, {
                  class: "getCode",
                  size: "small",
                  disabled: disableds.value,
                  onClick: getCode
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(content.value), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          modelValue: formData.value.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.code) = $event)),
          modelModifiers: { trim: true },
          left: "",
          clearable: "",
          placeholder: "请输入验证码",
          rules: [{ required: true, message: '请输入验证码' }],
          type: "number",
          class: "input_code",
          "input-class": "prevent-zoom",
          maxlength: "6",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (formData.value.code = formData.value.code.replace(/\s/g, '')))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_button, {
          round: "",
          color: "#ffcd01",
          type: "primary",
          class: "yellow_button",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})